{
  "next": "Dalej",
  "previous": "Wstecz"
}
